export const SEARCH_PHOTO = 'containers/TagDetail/SEARCH_PHOTO';
export const SEARCH_PHOTO_SUCCESS = 'containers/TagDetail/SEARCH_PHOTO_SUCCESS';
export const SEARCH_PHOTO_ERROR = 'containers/TagDetail/SEARCH_PHOTO_ERROR';

export const FILTER_ORDER_BY = 'containers/TagDetail/FILTER_ORDER_BY';
export const FILTER_PER_PAGE = 'containers/TagDetail/FILTER_PER_PAGE';

export const CHANGE_PAGE = 'containers/TagDetail/CHANGE_PAGE';
